export const ClaimsUserType = {
  CORP_AD: 'corp-ad',
  NOT_CORP_AD: 'not-corp-ad',
};
